import React, { type ReactElement, useState } from 'react'
import { useTheme } from '@mui/material/styles'
import { CircularProgress, Typography } from '@mui/material'
import verificationBackground from 'assets/verificationBackground.svg'
import ThemeSnackbar, { SNACKBAR_VARIANTS } from 'common/ui/theme-snackbar/ThemeSnackbar'
import ThemeButton from 'common/ui/theme-button'
import { StoreStatus } from 'common/utils/types'
import { useAppDispatch, useAppSelector } from 'store/hooks'

import { sendActivationEmail } from '../auth.service'

import styles from './InactiveAccount.module.scss'

const InactiveAccount: React.FC = (): ReactElement => {
  const { palette } = useTheme()
  const dispatch = useAppDispatch()
  const { sendActivationEmailStatus } = useAppSelector((state) => state.auth)
  const { vendor } = useAppSelector((state) => state.vendor)

  const [openSnackbar, setOpenSnackbar] = useState<boolean>(false)
  const [snackbarMessage, setSnackbarMessage] = useState<string>('')
  const sendActivationEmailHandler = (): void => {
    void dispatch(sendActivationEmail()).then(() => {
      setOpenSnackbar(true)
      setSnackbarMessage('Aktivacioni mail je poslat')
    })
  }

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url(${verificationBackground})`,
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className={styles.content}>
        <div
          style={{
            height: '135px',
            display: 'flex',
            justifyContent: 'space-evenly',
            flexDirection: 'column',
          }}
        >
          <Typography variant="paragraph" sx={{ lineHeight: '26px' }}>
            Uspešno ste se registrovali na Vendors aplikaciju.
          </Typography>
          <Typography variant="paragraph" sx={{ lineHeight: '26px' }}>
            Da biste koristili aplikaciju vaš nalog mora biti aktiviran.
          </Typography>
          <Typography variant="paragraph" sx={{ lineHeight: '26px' }}>
            Nakon što zatražite aktivaciju poslaćemo Vam link na mail koji vam je upisan u APR-u, klikom na
            link iz mail-a aktiviraćete svoj nalog.
          </Typography>
        </div>
        <Typography variant="paragraph" sx={{ lineHeight: '26px' }}>
          Mail na koji je poslat link: {vendor?.aprEmail}
        </Typography>
        <div className={styles.actionsRow}>
          <ThemeButton
            sx={{
              backgroundColor: palette.charts.green200.main,
              '&:hover': {
                backgroundColor: palette.charts.green200.main,
              },
            }}
            onClick={sendActivationEmailHandler}
            startIcon={
              sendActivationEmailStatus === StoreStatus.Loading ? (
                <CircularProgress size={16} color="primary" />
              ) : null
            }
            disabled={sendActivationEmailStatus === StoreStatus.Loading}
          >
            ZATRAŽI AKTIVACIJU
          </ThemeButton>
          <Typography variant="paragraph" sx={{ lineHeight: '26px' }}>
            Kontaktirajte podršku: cdt@pks.rs
          </Typography>
        </div>

        <ThemeSnackbar
          snackbarOpen={openSnackbar}
          variant={SNACKBAR_VARIANTS.success}
          message={snackbarMessage}
          onClose={() => {
            setOpenSnackbar(false)
            setSnackbarMessage('')
          }}
        />
      </div>
    </div>
  )
}

export default InactiveAccount
